/**
 * @typedef {Array<number>} columns
 * @typedef {Array<number>} rows
 */

import { trueSet } from "@/utils/pureFunctions.js";

/**
 * Enum for box place type
 * @readonly
 * @enum {string}
 */
// eslint-disable-next-line no-unused-vars
const PLACE_TYPE = {
  Corridor: "Corridor",
  Field: "Field",
  Stillage: "Stillage",
};

/**
 * @typedef  {Object} Box
 * @property {(number|string)} width - Box with
 * @property {(number|string)} height - Box height
 * @property {boolean} alarm - For mark box
 * @property {string} columnId - column id
 * @property {(number|undefined)} id
 * @property {PLACE_TYPE} placeType
 * @property {string} full ?
 * @property {string} hasProduct ?
 */

export class BoxService {
  /**
   *
   * @param defaultBoxSize {number}
   */
  constructor(defaultBoxSize) {
    this.defaultBoxSize = defaultBoxSize;
    this.rows = [];
    this.columns = [];
    this.boards = [];
  }

  /**
   * @param {Array<Box>}boxes
   */
  addRow(boxes) {
    if (boxes.length > this.rows.length) {
      let currentIndex = this.rows.length;
      for (let i = currentIndex; i < boxes.length; i++) {
        if (!boxes[i].height || boxes[i].height === "0") {
          boxes[i].height = this.defaultBoxSize;
        }
        this.rows.push(+boxes[i].height);
      }
    }
  }

  /**
   * @param boxes {Array<Box>}
   */
  addColumn(boxes) {
    if (boxes[0] && boxes[0].width && boxes[0].width !== "0") {
      this.columns.push(+boxes[0].width);
    } else {
      this.columns.push(this.defaultBoxSize);
    }
  }

  /**
   * @param {Array<Box>}boardBoxes
   * @param index {number}
   * @param columnId {number}
   */
  addToBoard(boardBoxes, index, columnId) {
    if (!this.boards[index]) this.boards[index] = [];
    boardBoxes.forEach((box) => {
      let width = this.defaultBoxSize;
      let height = this.defaultBoxSize;
      if (box.width && box.width !== "0") {
        width = box.width;
      }
      if (box.height && box.height !== "0") {
        height = box.height;
      }
      let full = box.full ? trueSet(box.full) : false;
      let hasProduct = box.hasProduct ? trueSet(box.hasProduct) : false;
      let alarm = trueSet(box.alarm);

      this.boards[index].push({
        id: box.id,
        width,
        height,
        placeType: box.placeType,
        columnId,
        full,
        hasProduct,
        alarm,
        stillageColor: box.stillageColor,
      });
    });
  }

  /**
   * @param data
   * @typedef {Object} ParseData
   * @property {rows} rows
   * @property {columns} columns
   * @property {Array<Array<Box>>} boards
   * @returns ParseData
   */
  parseData(data) {
    data.forEach((item, index) => {
      if (!item.rows) item.rows = [];
      this.addColumn(item.rows);
      this.addRow(item.rows);
      this.addToBoard(item.rows, index, item.id);
    });
    return {
      rows: this.rows,
      columns: this.columns,
      boards: this.boards,
    };
  }
}
